/**
 * context
 * 动态创建的 context 和 provider
 * 通过传入的namespace来区分不同的语言包模块
 * 因为语言包是通过 useLanguage 使用时进行加载的，在使用时会自动加载相关联的context中的语言
 *
 * Created by Samuel on 2022/8/18
 */
import { createContext, useMemo, useState } from 'react';

import { useCallbackRef } from '@core/hooks/useCallbackRef';
import { useConfig } from '@core/hooks/useConfig';
import Index from '@core/i18n/index';
import { clearLangCache } from '@core/i18n/lang';

export const createLanguageBlock = (config) => {
	const LanguageContext = createContext({});

	const ConfigProvider = ({ children }) => {
		const globalConfig = useConfig();
		const [conf, setConf] = useState(() => {
			const _conf = config;
			_conf.intl = new Index.MgIntl({
				language: _conf.language,
				path: globalConfig.localesPath,
				version: globalConfig.localesVersion,
				supportedLanguage: _conf.supportedLanguage || globalConfig.supportedLanguage,
			});

			return _conf;
		});

		const changeLanguage = useCallbackRef((lang) => {
			conf.intl.changeLanguage(lang, () => {
				clearLangCache();
				setConf({
					...conf,
					language: lang,
				});
			});
		});

		const value = useMemo(() => ({ ...conf, changeLanguage }), [conf, changeLanguage]);

		return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
	};

	return {
		context: LanguageContext,
		Provider: ConfigProvider,
	};
};
